import { init, captureException, captureMessage, replayIntegration, browserTracingIntegration } from "@sentry/react";
const infoMessages = ["Tarrif not found"];
const errorMessagesToIgnore = [
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document",
  "Can't find variable: indexedDB",
  "URL REDIRECT",
  "Aborting execution, redirecting to split URL variation.",
  "Object captured as promise rejection with keys: message, name, toString",
  "Request aborted",
  "Tarrif not found",
  "StatusCode 0", // status 0 we get when Request Aborted,Browser-Specific Restrictions or Network Connectivity Issues so ignoring it
  "Failed to execute 'querySelectorAll' on 'Document': '*:not(html):not(head *):not(script):not(head , body , iframe)' is not a valid selector.", // it comes from convert.com
  "Cannot read properties of null (reading 'setItem')", // localstorage not available
  "Cannot read properties of null (reading 'getItem')", // localstorage not available
  "The operation is insecure.", // localstorage not available
  "(In 's.t(t)', 's.t' is undefined)", // convert error
  "Couldn't find refresh token", // when refresh token got expired
  "Request failed with status code 401",
  "Loading CSS chunk",
  "Unexpected token '<'", // we know this error apears when some user is on previous version of app, but then page got reloaded because of app version check hook
  "expected expression, got '<'",
  "Can't find variable: gmo",
  "SyntaxError: JSON Parse error: Unexpected identifier",
  "freshchat.com/js/widget.js",
  "ConstraintError: Key already exists in the object store",
  "Aborting execution.",
];

init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  // Make sure sentry is just allowed on dev | test | prod. Change your env var "SENTRY_ENVIRONMENT" in .env file to enable sentry to local testing.
  enabled: !!(
    process.env.SENTRY_ENVIRONMENT && ["mfe-dev", "mfe-test", "mfe-prod"].includes(process.env.SENTRY_ENVIRONMENT)
  ),
  ignoreErrors: errorMessagesToIgnore,
  // Performance Monitoring
  tracesSampleRate: 0.1, // Capture 10% of the transactions!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 50% when sampling sessions where errors occur.
  integrations: [
    browserTracingIntegration({
      interactionsSampleRate: 0.1, // Set UI interaction event sampling rate, e.g., 10%
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  beforeSend(event) {
    // info level messages only
    if (
      event.exception?.values?.some((value) => infoMessages.some((infoMessage) => value.value?.includes(infoMessage)))
    ) {
      event.level = "info";
    }

    // Filter out non-error promise rejection and exception captured
    if (
      event.exception?.values?.some(
        (value) =>
          value.value?.includes("Non-Error promise rejection captured") ||
          value.value?.includes("Non-Error exception captured")
      )
    ) {
      return null; // Don't send the event to Sentry
    }

    // Ensure the `endpoint` is set in `extra`
    const endpoint = (event.extra?.endpoint as string) || "";
    if (endpoint) {
      event.tags = { ...event.tags, endpoint };
    }

    return event;
  },
  denyUrls: [
    /https:\/\/.*\.freshchat\.com\/js\/widget\.js/,
    /freshchat\.com\/js\/widget\.js/,
    /convertexperiments\.com/,
  ],
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SentryError = (err: any, extra?: Record<string, unknown>) => {
  captureException(err, {
    extra,
  });
};

export const SentryMessage = (msg: string) => {
  captureMessage(msg);
};
